<app-spinner [visible]="visibleSpinner"></app-spinner>
<app-mensajes
  [code]="code"
  [titulo]="titulo"
  [detalle]="detalle"
  [sw]="sw"
></app-mensajes>
<div class="p-grid p-jc-center p-my-1">
  <div class="p-col-8" style="color: #495057;">
    <h2>Pagar mandamiento</h2>
    <!-- <hr style="border: 0; border-top: 1px solid #dee2e6;"> -->
    <div class="p-col-12">
      <div class="p-col-12" class="container-search">
        <div class="p-fluid p-grid p-formgrid">
          <div class="p-col-1" style="margin-top: 5px; text-align: center">
            Filtrar por:
          </div>
          <div class="p-col-3">
            <span class="p-input-icon-left" style="width: 100%">
              <i class="pi pi-search"></i>
              <input
                type="text"
                pInputText
                placeholder="Número de mandamiento"
                [(ngModel)]="numeroMandamiento"
                style="width: 100%"
                class="p-inputtext-sm"
                (keyup.enter)="filter()"
              />
            </span>
          </div>          
          <div class="p-col-2">
            <button
              pButton
              type="button"
              label="Filtrar"
              [disabled]="searching"
              icon="pi pi-search"
              class="p-button-sm ui-button-info"
              (click)="filter()"
              style="border: 1px solid #607D8B; background: #607D8B;"
            ></button>
          </div>
        </div>
      </div>
      <div class="p-col-12" *ngIf="notFoundFlag" style="display: flex; justify-content: center;">
        <div class="error-section">
          <div class="pretty-alert pretty-alert--error">
            <div class="pretty-alert--message">
              <p style="padding-left: 5em; padding-right: 5em;" [innerHTML]="errorMessage"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="p-col-12" *ngIf="mostrarDetalles">
        <h4>Detalles del pago ({{numeroMandamiento}})</h4>
        <p> A continuación se muestran los detalles del pago, recuerda tener a la mano tu tarjeta de débido/crédito antes de iniciar el proceso de pago</p>
        <section class="p-grid" >
          <div class="p-col-12">
            <table>
              <tr>
                <td style="width: 10%;"><b>NPE:</b> {{ mandamiento.npe }}</td>
                <td style="width: 10%;"><b>Solicitud:</b> {{ mandamiento.solicitud.numero_solicitud}}</td>
              </tr>
            </table>
            <br>
            <p-table [value]="mandamiento.detalles" dataKey="correlativo">
                <ng-template pTemplate="header">
                    <tr class="custom-th">
                        <th class="custom-th">DETALLE</th>
                        <th class="custom-th">($) VALOR</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-detalle>
                    <tr class="custom-th">
                        <td class="custom-td">{{detalle.nombre_tipo_pago}}</td>
                        <td class="custom-td">$ {{detalle.valor}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                    <tr class="custom-th">
                        <td class="custom-td">TOTAL</td>
                        <td class="custom-td">$ {{mandamiento.total}}</td>
                    </tr>
                </ng-template>
            </p-table>
            <br>
          </div>
          <div class="p-col-12">
            <div class="p-grid">
              <div class="p-col-12" style="display: flex; justify-content: center;">
                <div class="input-group" *ngIf="!mandamiento.pagado">
                  <button pButton [label]="!processing ? ('Pagar $' + mandamiento.total) : 'Procesando pago...'" [icon]="processing ? 'pi pi-spin pi-spinner' : 'pi pi-money-bill'" [disabled]="processing" (click)="makePayment(mandamiento.id, mandamiento.total)" style="background-color: #313945; border-color: #0D1175; width: 15em; height: 3em;"></button>
                </div>
                <div class="error-section" *ngIf="mandamiento.pagado && !(successFlag || errorFlag)">
                  <div class="pretty-alert pretty-alert--error">
                    <div class="pretty-alert--message">
                      <p style="padding-left: 3em; padding-right: 3em;">¡El mandamiento ya ha sido pagado!</p>
                    </div>
                  </div>
                </div>
                <div class="error-section" *ngIf="successFlag">
                  <div class="pretty-alert pretty-alert--success">
                    <div class="pretty-alert--message">
                      <p style="padding-left: 3em; padding-right: 3em;" [innerHTML]="errorMessage"></p>
                    </div>
                  </div>
                </div>
                <div class="error-section" *ngIf="errorFlag">
                  <div class="pretty-alert pretty-alert--error">
                    <div class="pretty-alert--message">
                      <p style="padding-left: 3em; padding-right: 3em;" [innerHTML]="errorMessage"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-12" style="display: flex; justify-content: center;" *ngIf="mandamiento.pagado && mandamiento.habilitar_comprobante">
              <div class="input-group">
                <button pButton [label]="!processing ? ('Ver comprobante de pago') : 'Cargando...'" [icon]="processing ? 'pi pi-spin pi-spinner' : 'pi pi-external-link'" (click)="verComprobante(mandamiento.id)" style="background-color: #313945; border-color: #0D1175;"></button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>